import { App, areAppTypesEquivalent } from '@ps20-frontend/frontend-models';
import { IAppState } from '../localStore';
import { Produkt, Sicherungsglaeubiger } from '../model';
import { selectVWGProdukteWithoutBeibehaltung } from './produkt.selector';

export const glaeubigerSelector = (state: IAppState): Array<Sicherungsglaeubiger> =>
  state.sicherungsglaeubiger;

export const isVWGErsatzgeschaeft = (state: IAppState): boolean => {
  const vwgProdukt: Produkt = state.produkte.find(produkt => areAppTypesEquivalent(produkt.appId, App.VWG));
  return vwgProdukt !== undefined && vwgProdukt.vorvertragsnummer != null;
};

export const selectAdresseToDisplay = (state: IAppState): string => {
  const adresse: Produkt = selectVWGProdukteWithoutBeibehaltung(state).find(
    elem => areAppTypesEquivalent(elem.appId, App.VWG),
  );

  return adresse ? adresse.versichertesRisiko : '';
};

export const selectSicherungsglaeubigerForAngebot = (
  sicherungsglaeubiger: Array<Sicherungsglaeubiger>,
  angebotsId: string,
): Array<Sicherungsglaeubiger> =>
  sicherungsglaeubiger?.filter(value => value.angebotsId === angebotsId);
